import { SWRConfiguration } from 'swr';

import { DocumentType } from '~/data/documents/types';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

const SWR_KEY_useGetCompanyDocuments = 'useGetCompanyDocuments';

export const getCompanyDocuments = async (): Promise<DocumentType[]> => {
  return fetchFromOldApi('/json/company/file').then((r) => r.json());
};

export const useGetCompanyDocuments = (
  swrConfig?: SWRConfiguration<DocumentType[]>,
  isDisabled?: boolean,
): UseArraySWROutput<DocumentType> => {
  return useArraySWR(
    !isDisabled ? [SWR_KEY_useGetCompanyDocuments] : null,
    () => getCompanyDocuments(),
    swrConfig,
  );
};
